export default __webpack_public_path__ + "static/media/logo_black.e07fe492.png";